export interface PhaseOpenContext {
  lifecycleCompleted: boolean;
  activePhaseOrder: number;
  expanded: Set<number>;
  phaseMenuOpen: boolean;
  phaseMenuOrder?: number;
}

export interface PhaseOpenDecision {
  open: boolean;
  expandedChanged: boolean;
}

export const parseExpandedPhases = (raw: string | null): Set<number> => {
  if (!raw) return new Set<number>();
  try {
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? new Set(parsed.filter((x): x is number => typeof x === 'number')) : new Set<number>();
  } catch {
    return new Set<number>();
  }
};

export const serializeExpandedPhases = (expanded: Set<number>): string => JSON.stringify([...expanded]);

export const decidePhaseOpen = (order: number, ctx: PhaseOpenContext): PhaseOpenDecision => {
  if (ctx.lifecycleCompleted) {
    return { open: ctx.expanded.has(order), expandedChanged: false };
  }
  if (order === ctx.activePhaseOrder) {
    // The auto-opened phase has to be stored too: once the lifecycle fails or completes, only stored phases reopen.
    if (ctx.expanded.has(order)) return { open: true, expandedChanged: false };
    ctx.expanded.add(order);
    return { open: true, expandedChanged: true };
  }
  if (ctx.expanded.has(order)) {
    return { open: true, expandedChanged: false };
  }
  if (ctx.phaseMenuOpen && ctx.phaseMenuOrder != undefined) {
    return { open: ctx.phaseMenuOrder == order, expandedChanged: false };
  }
  return { open: false, expandedChanged: false };
};
